import { createAction } from 'redux-actions';

export const GetListQARequested = createAction('GET_LIST_QA_REQUESTED');
export const GetListQARequestedReceived = createAction('GET_LIST_QA_REQUESTED_RECEIVED');
export const GetListQARequestedReceivedFailure = createAction('GET_LIST_QA_REQUESTED_RECEIVED_FAILURE');

export const createQARequested = createAction('CREATE_QA_REQUESTED');
export const createQARequestedReceived = createAction('CREATE_QA_REQUESTED_RECEIVED');
export const createQARequestedReceivedFailure = createAction('CREATE_QA_REQUESTED_RECEIVED_FAILURE');

export const updateQARequested = createAction('UPDATE_QA_REQUESTED');
export const updateQARequestedReceived = createAction('UPDATE_QA_REQUESTED_RECEIVED');
export const updateQARequestedReceivedFailure = createAction('UPDATE_QA_REQUESTED_RECEIVED_FAILURE');

export const deleteQARequested = createAction('DELETE_QA_REQUESTED');
export const deleteQARequestedReceived = createAction('DELETE_QA_REQUESTED_RECEIVED');
export const deleteQARequestedReceivedFailure = createAction('DELETE_QA_REQUESTED_RECEIVED_FAILURE');

export const clearListQA = createAction('CLEAR_LIST_QA');
